import { DAY } from '@/lib/constants';

export const MANUAL_REFRESH_COOLDOWN_DAYS = {
  SCAN_ACCESS: 1,
  PAID: 3,
  FREE: 60,
} as const;

export const MANUAL_REFRESH_COOLDOWN_MS = {
  SCAN_ACCESS: MANUAL_REFRESH_COOLDOWN_DAYS.SCAN_ACCESS * DAY,
  PAID: MANUAL_REFRESH_COOLDOWN_DAYS.PAID * DAY,
  FREE: MANUAL_REFRESH_COOLDOWN_DAYS.FREE * DAY,
} as const;

// Maximum characters allowed in custom instructions for wiki generation prompts.
export const CUSTOM_INSTRUCTIONS_MAX_LENGTH = 10000;
